import isValidDateString from "./isValidDateString"

export default function(label) {
    const isDate = isValidDateString(label)
    if (isDate) {
        // Format date to short human readable string (e.g. 13 Jan 2023)
        const match = /^(\d{2})[-\/](\d{2})[-\/](\d{4})$/.exec(label)
        let date
        if (match) {
            const [ , day, month, year ] = match
            date = new Date(`${year}-${month}-${day}`)
        } else {
            date = new Date(label)
        }
        return date.toLocaleDateString('da-DK', { day: '2-digit', month: 'short', year: 'numeric' })
    }
    return label
}